var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShekelSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M248 168v168c0 8.84 7.16 16 16     16h48c8.84 0 16-7.16     16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0     56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16     16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16     7.16-16 16v296c0 30.93-25.07 56-56     56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16     7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0     136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekelSign);
export default __webpack_public_path__ + "static/media/shekel-sign.e26c0089db481e55f22fccede89bdeab.svg";
export { ForwardRef as ReactComponent };